// Walter Portal's "Accéder à WalterIA" button opens the CRM with ?walter_ia=open.
const WALTER_IA_OPEN_REQUEST = "walter_ia_open_requested";

/**
 * Remembers a ?walter_ia=open request before anything can drop it: the SSO round trip
 * and the home landing redirect both leave the URL without its query string.
 */
export function rememberWalterIaOpenRequest() {
    if (new URLSearchParams(window.location.search).get("walter_ia") === "open") {
        sessionStorage.setItem(WALTER_IA_OPEN_REQUEST, "1");
    }
}

/** Returns whether Walter IA was asked for, and forgets the request. */
export function takeWalterIaOpenRequest() {
    const requested = sessionStorage.getItem(WALTER_IA_OPEN_REQUEST) === "1";
    sessionStorage.removeItem(WALTER_IA_OPEN_REQUEST);
    return requested;
}
